export default __webpack_public_path__ + "static/media/kitchen3-before3-480w.c0c17d43.webp";